<ng-container *ngIf="newHomePedirDelivery">
	<div *ngIf="item.type != 'general' || item.hasStock !== false || showStockPausedItems() || allRequiredExtrasOutOfStock"
		data-cy="menuItem"
		class="product-card-new-design hover-anim"
		[ngClass]="{'card-product__without-stock' : item.hasStock === false, 'product-card--disabled' : allRequiredExtrasOutOfStock, 'product-card--list': !isFeatured, 'product-card--no-description': !isFeatured && !item.description && !item.tag, 'product-card--no-image': !hasImageSlot, 'product-card--no-text': !hasTextBlock}"
		(click)="!allRequiredExtrasOutOfStock && goToItemPage(item)">
		<div class="card-container">
			<div class="info-container" [class.title-short]="isShortTitle()">
				<div class="tag-container" *ngIf="item.tag">
					<span class="product-tag">{{item.tag}}</span>
				</div>
				<h3 class="item-name">{{item.name}}</h3>
				<p class="unavailable-text" *ngIf="item.hasStock === false || allRequiredExtrasOutOfStock" data-cy="hasStock">
					Indisponível no momento
				</p>
				<div *ngIf="hasTextBlock" class="text-block" [class.has-tag]="item.tag">
					<p *ngIf="isInstagramUA && item.description" class="item-description">
						{{descriptionText}}
					</p>
					<p *ngIf="!isInstagramUA && item.description"
					[innerHTML]="descriptionHtml"
					class="item-description">
					</p>
				</div>
				<div class="price-container">
					<div *ngIf="item.price > 0 && !item.fromPrice" class="price-content">
						<span class="current-price">{{item.price | multiCurrency}}</span>
						<span *ngIf="showOldPrice" class="old-price">{{item.oldPrice | multiCurrency}}</span>
					</div>
					<div *ngIf="item.fromPrice" class="price-content">
						<span class="from-text">{{'From_price' | translate}} </span>
						<span class="price-value">{{item.fromPrice | multiCurrency}}</span>
						<span *ngIf="showOldPrice" class="old-price">{{item.oldPrice | multiCurrency}}</span>
					</div>
				</div>
			</div>
			
			<div *ngIf="hasImageSlot" class="image-container" (click)="item.image && openViewer(item); $event.stopPropagation();">
				<mp-img *ngIf="item.image" class="item-image" imgURL="{{imgURL}}/products/{{item.image}}/thumb_{{item.image}}.jpg"></mp-img>
				<img *ngIf="!item.image && isFeatured" class="item-image" [src]="defaultImage" alt="{{item.name}}">
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!newHomePedirDelivery">
	<ion-card *ngIf="item.type != 'general' || item.hasStock !== false || showStockPausedItems() || allRequiredExtrasOutOfStock" data-cy="menuItem" class="product-card hover-anim" [ngClass]="{'card-product__without-stock' : item.hasStock === false, 'product-card--disabled' : allRequiredExtrasOutOfStock}" mode="md" (click)="!allRequiredExtrasOutOfStock && goToItemPage(item)">
		<!-- `ion-grid`/`ion-row`/`ion-col` viraram divs com o MESMO flex (Caso 17-B).
		     Não é economia de nó — a contagem de luz é idêntica: é economia de
		     COMPONENTE. Cada um dos três é um custom element do Stencil com shadow
		     root próprio; num cardápio de 2.000 produtos eram ~6.000 elementos para
		     definir, "upgradar" e carregar folha de estilo, para produzir
		     `display:flex` e uma largura em porcentagem. As porcentagens ficam na
		     forma exata que o ion-col gerava (o `calc` com `--ion-grid-columns`),
		     então quem sobrescrever a variável continua atendido. -->
		<div class="pc-grid">
			<div class="pc-row">
				<div class="pc-col pc-col--media centralize" *ngIf="item.image">
					<mp-img class="item-image" imgURL="{{imgURL}}/products/{{item.image}}/thumb_{{item.image}}.jpg" (click)="openViewer(item); $event.stopPropagation();"></mp-img>
				</div>
				<div class="pc-col pc-col--body" [class.pc-col--narrow]="item.image">
					<ion-card-header class="pb-0">
						<ion-card-title class="text-wrap item-name">{{item.name}}</ion-card-title>
						<ion-label class="text-wrap text-right" *ngIf="item.hasStock === false || allRequiredExtrasOutOfStock" data-cy="hasStock">
							Indisponível no momento
						</ion-label>
					</ion-card-header>
					<ion-card-content>
						<!-- `hasDescription` (Caso 17-B): os dois ion-label da descrição não
						     tinham *ngIf — nasciam VAZIOS em todo produto sem descrição, que é
						     a esmagadora maioria numa distribuidora. O `<br>` abaixo NÃO sai
						     junto: medido, ele vale ~21px de altura em TODO card (é ele que
						     separa descrição de preço), então removê-lo encolheria a lista. -->
						<ion-label *ngIf="isInstagramUA && hasDescription" class="text-wrap">{{descriptionText}}</ion-label>
						<!-- innerHTML num span interno: bindar direto no ion-label (host Stencil) faz o
						     polyfill de slot do Ionic 8 engolir o conteúdo (vira comentário s-nt) -->
						<ion-label *ngIf="!isInstagramUA && hasDescription" class="text-wrap"><span [innerHTML]="descriptionHtml"></span></ion-label>
						<br>
						<ion-label class="product-card-label" *ngIf="item.price > 0 && !item.fromPrice">
							{{item.fromPrice}}
							<b *ngIf="showOldPrice"><del style="color:grey;">{{item.oldPrice | multiCurrency}}</del>&nbsp;</b>
							<b>{{item.price | multiCurrency}}</b>
						</ion-label>
						<ion-label class="product-card-label" *ngIf="item.fromPrice">
							<b>{{'From_price' | translate}} </b>
							<del style="color:grey;" *ngIf="showOldPrice">{{item.oldPrice | multiCurrency}} </del>
							<b>{{item.fromPrice | multiCurrency}}</b>
						</ion-label>
					</ion-card-content>
				</div>
			</div>
			<div class="pc-row" *ngIf="item.tag">
				<div class="pc-col pc-col--tag text-center">
					<ion-text class="product-tag">{{item.tag}}</ion-text>
				</div>
			</div>
		</div>
	</ion-card>
</ng-container>